import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useSelectedProduct } from '../contexts/SelectedProductContext';

function ProductSwitchModal({ show, handleClose }) {
    const navigate = useNavigate();
    const { setSelectedProduct, setIsFromUI } = useSelectedProduct();

    const handleProductSelect = (product) => {
        setIsFromUI(true);  // Ensure UI-based switch is recognized
        setSelectedProduct(product);
        navigate(`/${product}/dashboard`); // Navigate to selected product
        handleClose(); // Close modal
    };

    return (
        <Modal show={show} onHide={handleClose} dialogClassName="modal-90w" aria-labelledby="contained-modal-title-vcenter" centered>
            {/* Modal Body */}
            <Modal.Body className="p-5">
                <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="modal-title text-start">
                            <h3>Select the product to switch to</h3>
                        </div>

                        {/* Product Boxes - Clickable to switch products */}
                        <div className="row pt-4">
                            <div className="col-sm-12 col-md-3 col-lg-3" onClick={() => handleProductSelect('product1')}>
                                <img loading="lazy" alt="Product Images" src="/assets/images/product-1.png" className="w-100 bg-light-one" />
                                <div
                                    className="box-1" style={{ cursor: 'pointer' }}>
                                    <h4>Multi Hazard Mapping</h4>
                                    <p className="mb-0">Multi-hazard mapping from historical natural disaster data guides Africa’s regional-to-national adaptation planning and investment</p>
                                    <a role="button" className="ps-0 linkAbouts nav-link text-end mb-4" tabIndex="0" href='#'>Click to explore <span><img alt="" src="/assets/images/arrow_forward.png" /></span></a>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3" onClick={() => handleProductSelect('product2')}>
                                <img loading="lazy" alt="Product Images" src="/assets/images/product-2.png" className="w-100" />
                                <div
                                    className="box-2" style={{ cursor: 'pointer' }}>
                                    <h4>Vulnerability and Risk Analysis</h4>
                                    <p className="mb-0">Assessing climate risk to Africa’s agriculture, water, and nutrition security to inform policies and sustainable development</p>
                                    <a role="button" className="ps-0 linkAbouts nav-link text-end mb-4" tabIndex="0" href='#'>Click to explore <span><img alt="" src="/assets/images/arrow_forward.png" /></span></a>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3" onClick={() => handleProductSelect('product3')}>
                                <img loading="lazy" alt="Product Images" src="/assets/images/product-3.png" className="w-100" />
                                <div
                                    className="box-3" style={{ cursor: 'pointer' }}>
                                    <h4>Flood Forecasting and Early Warning</h4>
                                    <p className="mb-0">Watch how our Flood Forecasting and Early Warning System enhances community preparedness and helps authorities take timely action</p>
                                    <a role="button" className="ps-0 linkAbouts nav-link text-end mb-4" tabIndex="0" href='#'>Click to explore <span><img alt="" src="/assets/images/arrow_forward.png" /></span></a>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-3 col-lg-3" onClick={() => handleProductSelect('product4')}>
                                <img loading="lazy" alt="Product Images" src="/assets/images/product-4.png" className="w-100" />
                                <div
                                    className="box-4" style={{ cursor: 'pointer' }}>
                                    <h4>Flood and Drought Monitor</h4>
                                    <p className="mb-0">The first of its kind, creating continental-scale satellite-based flood and drought monitoring to empower stakeholders, enhance preparedness, and guide mitigation efforts</p>
                                    <a role="button" className="ps-0 linkAbouts nav-link text-end mb-4" tabIndex="0" href='#'>Click to explore <span><img alt="" src="/assets/images/arrow_forward.png" /></span></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ProductSwitchModal;
